module.exports = __webpack_public_path__ + "img/pr-2.0b385e0b.png";